module.exports = __webpack_public_path__ + "media/sini_mueter.32f76fa1.mp3";